import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import {
  betStore,
  isMobile,
  freeBetStore,
  useTranslation,
  SlowConnectionWr,
  userSettingsStore,
  BetNotificationWr,
  UnderMaintenanceWr,
  LeftContainerHeader,
  MaxWinPopup,
  FreeBetMaxPayoutPopUp,
  useSoundWatcher,
} from '@pascal/pascal-core';
import engine from '../engine';

import { BetAmountSection } from '../../conatiners';
import { getRoundLifeCycle } from '../canvasDrawer';
import { LastResults, Timer } from '../../components';
import { canvasConfig } from '../../constants/canvasConfig';
import { globalTranslationKeys, roundStates } from '../../enums';
import { doBetsStore, roundsInfoStore } from '../../store';
import { canvasMouseCoordsFixer, getGameCanvasStandards, resizeGameCanvas } from '../../helpers/gameCanvasHelper';

import fastTradeLogoLight from '../../assets/images/game/fastTradeLogo-light.png';
import fastTradeLogoDark from '../../assets/images/game/fastTradeLogo-dark.png';
import {
  AdditionalResponseCode,
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
} from '../../enums/additionalResponseCodes';

export const GameMain = observer(() => {
  const { isShowBetBlocks, setIsRequiredRedrawGame } = doBetsStore;
  const { setHigher, setLower, animatingPoints } = roundsInfoStore;
  const { isDarkModeOn } = userSettingsStore;
  const { activeFreeBet } = freeBetStore;
  const t = useTranslation();
  useSoundWatcher();

  useEffect(() => {
    setIsRequiredRedrawGame(true);
  }, [isDarkModeOn]);

  useEffect(() => {
    resizeGameCanvas(canvasConfig.height, canvasConfig.width);
    setHigher(t(globalTranslationKeys.Higher).toUpperCase());
    setLower(t(globalTranslationKeys.Lower).toUpperCase());
  }, []);

  useEffect(() => {
    const { canvas } = getGameCanvasStandards();
    const { setMouseOnCanvas, setIsRequiredRedrawGame, handleClickOnCanvas, hoveringBlock, setHoveredBlock } =
      doBetsStore;

    const updateMouseOnCanvas = (e) => {
      const { x, y } = canvasMouseCoordsFixer(e.offsetX, e.offsetY);
      getRoundLifeCycle() === roundStates.roundStart && hoveringBlock();
      setMouseOnCanvas(x, y);
    };

    const mouseOutOfCanvas = () => {
      setMouseOnCanvas(-1, -1);
      doBetsStore.hoveredBlock && setHoveredBlock(null);
    };

    const clickOnCanvas = (e) => {
      const { x, y } = canvasMouseCoordsFixer(e.offsetX, e.offsetY);
      getRoundLifeCycle() === roundStates.roundStart && setIsRequiredRedrawGame(true);
      handleClickOnCanvas(x, y);
    };

    !isMobile() && canvas.addEventListener('mousemove', updateMouseOnCanvas);
    !isMobile() && canvas.addEventListener('mouseout', mouseOutOfCanvas);
    canvas.addEventListener('click', clickOnCanvas);

    return () => {
      !isMobile() && canvas.removeEventListener('mousemove', updateMouseOnCanvas);
      !isMobile() && canvas.removeEventListener('mouseout', mouseOutOfCanvas);
      canvas.removeEventListener('click', clickOnCanvas);
    };
  }, []);

  return (
    <>
      <BetNotificationWr
        translationDynamicValues={{ value: `x${activeFreeBet?.minOdd}` }}
        AdditionalErrorMessages={AdditionalErrorMessages}
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        AdditionalResponseCode={AdditionalResponseCode}
      />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <MaxWinPopup />
      <FreeBetMaxPayoutPopUp />
      <div className='lucky-deal-game-wrap'>
        <div className='f-g-prov-wrapper'>
          <LeftContainerHeader />
        </div>
        <canvas id='game-canvas' dir='ltr' />
        {!isMobile() && (
          <div className='logo-content'>
            <img src={userSettingsStore.isDarkModeOn ? fastTradeLogoDark : fastTradeLogoLight} alt='' />
          </div>
        )}
        <Timer />
        <LastResults />
        {isShowBetBlocks && <BetAmountSection />}
      </div>
    </>
  );
});
